import * as React from "react";
import { Modal,Button} from "antd";
import { connect } from "react-redux";


interface INounsubscribeProps {
  id:any;
  nounsubscribe:any;
  label: any;
  style: any;
  status:any;
  getOrderDetails:any;
}

class Nounsubscribe extends React.Component<INounsubscribeProps, any> {
  state = {
    visible:false,
    content:'',
  };
  constructor(props: INounsubscribeProps) {
    super(props);
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  
  show(id) {
    this.setState({
      visible:true
    })
  }

  onChange =(value) => {
    this.setState({
      content:value.target.value
    })     
  }
  
  submit = () =>{
    const param: any = {
      id: this.props.id,
      order_status:this.props.status,
      content:this.state.content,
    }; 
    this.props.nounsubscribe({
      ...param,
      callback: (data) => {
        if(data.res.code != 1001){
          this.handleCancel();
          const params: any = {
            id: this.props.id
          }; 
          this.props.getOrderDetails({
             ...params,
             callback: () => {
             }
           });
         }
      }
     }); 
  }


  render() {
    return (
      <React.Fragment>
      <Button type="primary" style={{...this.props.style,paddingLeft: "28",paddingRight: "28", backgroundColor: "#2b9fbd" }}  onClick={this.show.bind(this,this.props.id)}><div>{this.props.label}</div></Button> 
      <Modal maskClosable={false} onCancel={this.handleCancel} onOk={this.submit} title="确认信息"  visible={this.state.visible}  width="auto" centered={true}>
      <div className="abnormal">
            是否取消退订订单吗？ 
      </div>
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  status: state.orderDetails.status,
});

const mapDispatch = dispatch => {
  return {
    sendMail:dispatch.orderDetails.sendMail,
    nounsubscribe:dispatch.orderDetails.nounsubscribe,
    getOrderDetails:dispatch.orderDetails.getOrderDetails,
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Nounsubscribe);
